export interface FullscreenSettings {
    /**
     * Enable/Disable fullscreen option
     */
    fullScreen: boolean;
}

export const fullscreenSettings: FullscreenSettings = {
    fullScreen: true,
};
